import {
  Breadcrumb,
  Checkbox,
  Col,
  List,
  Row,
  Skeleton,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";

import { moveIn } from "./data";

import {
  HomeOutlined,
  FolderOpenOutlined,
  FileOutlined,
} from "@ant-design/icons";

import Information from "./components/information";
import ApplicationInfo from "./components/applicationInfo";
import Offer from "./components/offer";
import OfferProperty from "./components/offerProperty";
import NotifyOwner from "./components/notifyOwner";
import Inspections from "./components/inspections";
import PropertyAccepted from "./components/propertyAccepted";
import MoveinPrep from "./components/moveinPrep";
import AfterMovein from "./components/afterMoveIn";
import Info from "./components/info";
import InspectProperty from "./components/inspectProperty";
import StaffToInspect from "./components/staffToInspect";
import SetupTenant from "./components/setupTenant";
import CancelShowing from "./components/cancelShowings";
import SendWelcomeEmail from "./components/sendWelcomeEmail";
import EndLawnCare from "./components/endLawnCare";
import EndUtilities from "./components/endUtilities";
import VerifyProratedRentPaid from "./components/verifyProratedRentPaid";
import AddTenantTags from "./components/addTenantTags";
import SendMoveinCode from "./components/sendMoveinCode";
import CodeboxPickup from "./components/codeboxPickup";
import MoveInCancelled from "./components/moveInCancelled";
import CompleteMovein from "./components/completeMovein";
import FAQLinks from "./components/FAQLinks";
import { useParams } from "react-router-dom";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../firebase";

const { Text } = Typography;

function MoveIn({ data, alreadyCheckedItems }) {
  const { id } = useParams();

  const [itemId, setItemId] = useState(1);

  const [listId, setListId] = useState(null);
  const [checkedItems, setCheckedItems] = useState(alreadyCheckedItems || {});

  useEffect(() => {
    if (alreadyCheckedItems) {
      setCheckedItems(alreadyCheckedItems);
    }
  }, [alreadyCheckedItems]);

  const handleOnClick = (index, listId) => {
    setItemId(index);
    setListId(listId);
  };

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");
  const updateAssignedWorkItemListStatus = async (targetDocId, idStatusMap) => {
    const targetDocRef = doc(assignedCollectionRef, targetDocId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status: idStatusMap[item.id.toString()]
                ? "completed"
                : "incompleted",
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  useEffect(() => {
    const length = Object.keys(checkedItems).length;
    if (length) {
      updateAssignedWorkItemListStatus(id, checkedItems);
    }
  }, [checkedItems]);

  const handleCheckBoxClick = (e, index, itemId) => {
    // Prevent the item click from being triggered when clicking the checkbox
    e.stopPropagation();
    // Update the checked state of this item
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [itemId.toString()]: !prevCheckedItems[itemId.toString()],
    }));
  };
  return (
    <div className="make-ready">
      <Row gutter={[16, 0]}>
        <Col span={8}>
          <Row gutter={[0, 24]} className="make-ready-container">
            <Col span={24}>
              <span className="make-ready-icon">🚚</span>
            </Col>
            <Col span={24}>
              <Breadcrumb>
                <Breadcrumb.Item className="item-hover-effect">
                  <HomeOutlined /> <span>Library</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item className="item-hover-effect">
                  <FolderOpenOutlined />{" "}
                  <span>Property Management Process</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item className="item-hover-effect">
                  <FileOutlined /> <span>Move In</span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col span={24}>
              <Row>
                <Col>
                  <p className="heading-para">F. Move In 2:11PM workflow run</p>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <List
                className="list-container"
                itemLayout="horizontal"
                dataSource={data?.workItemList}
                bordered
                renderItem={(item, index) => (
                  <List.Item
                    className="list-item"
                    onClick={() => handleOnClick(item?.id, data?.docId)}
                  >
                    <Skeleton
                      avatar
                      title={false}
                      loading={item.loading}
                      active
                    >
                      <List.Item.Meta
                        avatar={
                          <div className="item-container">
                            <span>{index + 1}. </span>
                            {item.checkBox && (
                              <Checkbox
                                onClick={(e) =>
                                  handleCheckBoxClick(e, index, item.id)
                                }
                                checked={!!checkedItems[item.id.toString()]}
                              ></Checkbox>
                            )}
                            <Text
                              strong={!item.checkBox && true}
                              delete={!!checkedItems[item.id.toString()]}
                            >
                              {item?.title}
                            </Text>
                          </div>
                        }
                      />
                    </Skeleton>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </Col>
        <Col span={16} className="right-container">
          {itemId === 1 && (
            <Information
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 2 && (
            <ApplicationInfo
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 3 && (
            <Offer
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 4 && (
            <OfferProperty
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 5 && (
            <NotifyOwner
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 6 && (
            <Inspections
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 7 && (
            <InspectProperty
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 8 && (
            <StaffToInspect
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 9 && (
            <PropertyAccepted
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 10 && (
            <CancelShowing
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 11 && (
            <SetupTenant
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 12 && (
            <SendWelcomeEmail
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 13 && (
            <MoveinPrep
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 14 && (
            <EndLawnCare
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 15 && (
            <EndUtilities
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 16 && (
            <VerifyProratedRentPaid
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 17 && (
            <AddTenantTags
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 18 && (
            <SendMoveinCode
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 19 && (
            <AfterMovein
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 20 && (
            <CodeboxPickup
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 21 && (
            <MoveInCancelled
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 22 && (
            <CompleteMovein
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 23 && (
            <Info
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 24 && (
            <FAQLinks
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default MoveIn;
